module.exports = new __parcel__URL__("spotlightHubElementThumbmail-dark.f2ea74e7.svg").toString();